// src/pages/Ajax.jsx

import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function Ajax() {
  return (
    <div
      className="min-h-screen bg-[#111111] text-white flex flex-col"
      style={{ fontFamily: "Roboto, sans-serif" }}
    >
      <Helmet>
        <title>Ajax Security Systems | SeguraTech Partner</title>
        <meta
          name="description"
          content="Ajax — one of the fastest-growing alarm and smart home security brands in the world. Discover our Ajax solutions today."
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <main className="flex-grow">
        {/* Intro Section */}
        <section className="max-w-6xl mx-auto px-4 py-16 text-center">
          <img
            src={`${process.env.PUBLIC_URL}/AjaxLogo.png`}
            alt="Ajax Systems Logo"
            className="mx-auto h-20 w-auto max-w-[75%] mb-6 object-contain"
          />

          <p className="mt-4 text-white/90 max-w-2xl mx-auto text-lg font-medium">
            Ajax is one of the fastest-growing alarm and smart home security
            systems in the world — built on reliability, innovation, and
            seamless connectivity.
          </p>
        </section>

        {/* Features Section */}
        <section className="max-w-6xl mx-auto px-4 py-12 border-t border-[#2E2E2E]">
          <h2 className="text-2xl text-[#C6A564] mb-6 font-light">
            Our Ajax Solutions
          </h2>

          <p className="text-white/80 mb-10 font-normal">
            From motion detection to full smart integration, Ajax offers modular
            solutions designed to keep your home and business secure.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">

            {/* Intrusion Detection */}
            <Link
              to="/alarms/ajax/intrusion-detection"
              className="block rounded-2xl border border-[#C6A564] bg-[#1A1A1A] p-6 hover:bg-[#222222] transition no-underline text-inherit"
            >
              <h3 className="text-lg text-[#C6A564] mb-2 font-light">
                Intrusion Detection
              </h3>

              <p className="text-white/70 font-normal">
                Motion sensors, door contacts, and glass break detectors that
                react instantly to intrusion attempts.
              </p>
            </Link>

            {/* Smart Control */}
            <div className="rounded-2xl border border-[#C6A564] bg-[#1A1A1A] p-6 hover:bg-[#222222] transition">
              <h3 className="text-lg text-[#C6A564] mb-2 font-light">
                Smart Control
              </h3>

              <p className="text-white/70 font-normal">
                Control your entire alarm system from anywhere using the Ajax
                app — arm, disarm, or check device status remotely.
              </p>
            </div>

            {/* Fire & Leak Detection */}
            <div className="rounded-2xl border border-[#C6A564] bg-[#1A1A1A] p-6 hover:bg-[#222222] transition">
              <h3 className="text-lg text-[#C6A564] mb-2 font-light">
                Fire & Leak Detection
              </h3>

              <p className="text-white/70 font-normal">
                Smart smoke, CO₂, and water leak detectors that alert you
                instantly and help prevent costly damage.
              </p>
            </div>

          </div>
        </section>
      </main>
    </div>
  );
}
